import React from "react";
import Moment from "moment";
import ChartistGraph from "react-chartist";

import {
  dailySalesChart,
  emailsSubscriptionChart,
  completedTasksChart
} from "./Charts";

import GridItem from "../Grid/GridItem";
import Card from "../Card/Card";

var Chartist = require("chartist");
var delays = 80,
  durations = 500;
let rarr = [];
let labels = [];
let series = [];
let graphHighestValue = 0,
  graphLowestValue = 0;
const UserActivityGraph = props => {
  if (props.graphData.length > 0) {
    var results = {},
      i;
    for (i = 0; i < props.graphData.length; i++) {
      const date = Moment(props.graphData[i].date.seconds * 1000).format(
        "YYYY/MM"
      );
      results[date] = results[date] || 0;
      results[date]++;
    }

    for (i in results) {
      if (results.hasOwnProperty(i)) {
        rarr.push({ date: i, counts: results[i] });
      }
    }

    let seriesInnerArray = [];
    for (i in rarr) {
      labels.push(rarr[i].date);
      seriesInnerArray.push(rarr[i].counts);
      if (rarr[i].counts > graphHighestValue) {
        graphHighestValue = rarr[i].counts;
      }
      if (rarr[i].counts < graphLowestValue) {
        graphLowestValue = rarr[i].counts;
      }
    }
    series.push(seriesInnerArray);
  }

  const userActivityChart = {
    data: {
      labels: labels,
      series: series
    },
    options: {
      lineSmooth: Chartist.Interpolation.cardinal({
        tension: 0
      }),
      low: 0,
      high: (graphHighestValue * 1.1), // we recommend you to set the high sa the biggest value + something for a better look
      chartPadding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }
    },
    animation: {
      draw: function(data) {
        if (data.type === "line" || data.type === "area") {
          data.element.animate({
            d: {
              begin: 600,
              dur: 700,
              from: data.path
                .clone()
                .scale(1, 0)
                .translate(0, data.chartRect.height())
                .stringify(),
              to: data.path.clone().stringify(),
              easing: Chartist.Svg.Easing.easeOutQuint
            }
          });
        } else if (data.type === "point") {
          data.element.animate({
            opacity: {
              begin: (data.index + 1) * delays,
              dur: durations,
              from: 0,
              to: 1,
              easing: "ease"
            }
          });
        }
      }
    }
  };

  return (
    <div>
      <GridItem xs={12} sm={12} md={12}>
        {/* <Card chart> */}

        {/* <ChartistGraph
          className="ct-chart"
          data={completedTasksChart3.data}
          type="Line"
          options={completedTasksChart3.options}
          listener={completedTasksChart3.animation}
        /> */}

        {/* </Card> */}
      </GridItem>
      <ChartistGraph
        className="ct-chart"
        data={userActivityChart.data}
        type="Line"
        options={userActivityChart.options}
        listener={userActivityChart.animation}
      />
    </div>
  );
};

export default React.memo(UserActivityGraph);
